import { ProductSummary } from "../../ProductSummary";
import { useEffect, useState } from "react";
import { useTaskCreation } from "../../../hooks/useTaskCreation";
import {
  IOptionProps,
  IOptionsProps,
} from "../../../@types/reactSelect/IOption";
import axios from "../../../services/axios";
import { MessageBalloon } from "../../MessageBalloon/Index";
import { DropdownV2, CounterInputV2, InputV2 } from "../../FormControlsV2";
import { useTranslation } from "react-i18next";

interface BagReceiveProps {}

export const BagReceive: React.FC<BagReceiveProps> = () => {
  const { t } = useTranslation();
  const [optionsProducts, setOptionsProducts] = useState<IOptionsProps>([]);
  const [classificationOption, setClassificationOption] =
    useState<IOptionProps | null>(null);
  const [productOption, setProductOption] = useState<IOptionProps | null>(null);
  const [quantity, setQuantity] = useState(0);

  const { payload, setPayload, setAllowTaskCreation, responsibleId, farmId } =
    useTaskCreation();

  useEffect(() => {
    axios.get("/products/all").then(({ data }) => {
      setOptionsProducts(
        data.map((el: any) => ({
          label: el.trade_name,
          value: el,
        })),
      );
    });
  }, []);

  useEffect(() => {
    setProductOption(null);
    setQuantity(0);
    setAllowTaskCreation(false);
  }, [classificationOption]);

  useEffect(() => {
    setQuantity(0);
    setAllowTaskCreation(false);
  }, [productOption]);

  useEffect(() => {
    if (quantity <= 0) {
      setAllowTaskCreation(false);
    } else {
      setValuesOnPayload();
    }
  }, [quantity]);

  function setValuesOnPayload() {
    const productSelected = productOption?.value as any;
    if (productSelected)
      setPayload({
        ...payload,
        changes: [
          {
            farm_id: farmId,
            assigned_user_id: responsibleId,
            product_id: productSelected?.id,
            ...(productSelected?.packaging_type === "BAGGED"
              ? { bag_quantity: quantity }
              : { quantity_kg: quantity }),
          },
        ],
      });
    setAllowTaskCreation(true);
  }

  const [mapTypes] = useState(new Map());
  const [optionTypes, setOptionTypes] = useState<IOptionsProps>([]);

  useEffect(() => {
    optionsProducts.map((el) =>
      mapTypes.set(
        (el?.value as any)?.classification,
        (el?.value as any)?.classification,
      ),
    );
    setOptionTypes(
      Array.from(mapTypes.keys()).map((el) => ({
        label: el,
        value: el,
      })),
    );
  }, [optionsProducts]);

  const classificationValue = classificationOption?.value as string | undefined;
  const productData = productOption?.value as any;

  return (
    <>
      <div className="balloon-container">
        <MessageBalloon
          text={t("taskCreation.help.oneTaskPerProduct")}
          pointed
        />
      </div>
      <DropdownV2
        name="bag-receive-classification"
        placeholder={t("taskCreation.fields.selectClassification")}
        options={optionTypes}
        value={classificationOption}
        menuMount="overlay"
        onChange={(opt) => setClassificationOption(opt)}
      />

      {classificationValue && (
        <>
          <DropdownV2
            name="bag-receive-product"
            placeholder={t("taskCreation.fields.selectProduct")}
            options={optionsProducts.filter(
              (el) => (el?.value as any)?.classification == classificationValue,
            )}
            value={productOption}
            menuMount="overlay"
            onChange={(opt) => setProductOption(opt)}
          />

          {productData && (
            <>
              <div style={{ width: "100%" }}>
                <div style={{ height: 10 }} />
                <span className="task-label">{t("taskCreation.fields.summary")}</span>

                <ProductSummary product={productData} />
              </div>

              <div className="balloon-container">
                <MessageBalloon
                  text={t(productData?.packaging_type === "BAGGED"
                    ? "productPackaging.bagQuantityHelp"
                    : "taskCreation.help.productQuantity")}
                  pointed
                />
              </div>

              <CounterInputV2
                name="bag-receive-quantity"
                label={productData?.packaging_type === "BAGGED" ? t("productPackaging.bagQuantity") : undefined}
                suffix={productData?.packaging_type === "BAGGED" ? t("productPackaging.bags") : "kg"}
                value={quantity}
                min={0}
                max={99999999}
                onChange={(v) => setQuantity(v)}
              />
              {productData?.packaging_type === "BAGGED" && (
                <InputV2
                  name="bag-receive-total-kg"
                  label={t("productPackaging.totalWeight")}
                  suffix="kg"
                  value={quantity * Number(productData?.bag_weight_kg || 0)}
                  disabled
                />
              )}
            </>
          )}
        </>
      )}
    </>
  );
};
